// Mock data per la dashboard - SOLO PREVIEW VISUALE
import { LOGO_URL } from "./mock";

export const MOCK_USER = {
  id: "socio-001",
  nome: "Mario",
  cognome: "Rossi",
  email: "mario.rossi@email.it",
  telefono: "+39 333 1234567",
  codiceFiscale: "RSSMRA85M01H501Z",
  numeroTessera: "ACDT-2026-0142",
  fotoUrl: null,
  iscrittoDal: "2026-03-15",
  scadenzaTesseramento: "2027-03-15",
  giorniRimanenti: 268,
  statoTesseramento: "attivo",
  iscrittoRegistro: true,
  scadenzaRegistro: "2027-03-15",
  cfdtAnno: 14,
  cfdtRichiesti: 20,
  pacchetto: "Premium",
  achievements: [
    { id: "tesserato", t: "Tesserato A.C.D.T.", date: "2026-03-15", icon: "BadgeCheck" },
    { id: "corso-base", t: "Corso Base Completato", date: "2026-04-22", icon: "GraduationCap" },
    { id: "registro", t: "Iscritto al Registro Nazionale", date: "2026-04-25", icon: "Award" },
  ],
};

export const MOCK_DOCUMENTS = [
  { id: "statuto", nome: "Statuto A.C.D.T.", tipo: "PDF", size: "248 KB", scope: "tutti", icon: "FileText" },
  { id: "deont", nome: "Codice Deontologico", tipo: "PDF", size: "180 KB", scope: "tutti", icon: "FileText" },
  { id: "cond", nome: "Codice di Condotta", tipo: "PDF", size: "165 KB", scope: "tutti", icon: "FileText" },
  { id: "tessera", nome: "Tessera Digitale (con QR)", tipo: "PDF", size: "320 KB", scope: "tutti", icon: "IdCard" },
  { id: "attestato-base", nome: "Attestato Corso Base", tipo: "PDF", size: "410 KB", scope: "corso", icon: "Award" },
  { id: "attestato-reg", nome: "Attestato Iscrizione Registro", tipo: "PDF", size: "385 KB", scope: "registro", icon: "FileBadge2" },
  { id: "carta", nome: "Carta Intestata personalizzata", tipo: "PDF", size: "95 KB", scope: "registro", icon: "Mail" },
  { id: "timbro", nome: "Timbro Digitale ufficiale", tipo: "PNG", size: "42 KB", scope: "registro", icon: "Stamp" },
];

export const MOCK_PAYMENTS = [
  { id: "p1", data: "2026-03-15", desc: "Tesseramento 2026 + Corso Base + Registro", importo: 218.90, metodo: "PayPal", stato: "completato" },
  { id: "p2", data: "2026-05-12", desc: "Masterclass GDPR Pigreco", importo: 49.00, metodo: "Stripe", stato: "completato" },
];

// ----- I MIEI CORSI (acquistati / iscritto) -----
// Ogni corso ha lezioni (video), materiali (PDF), quiz finale, attestato
export const MOCK_CORSI = [
  {
    id: "c1",
    titolo: "Consulente Digitale Tecnologico e di Sostenibilità",
    descrizione: "Il corso base obbligatorio per l'iscrizione al Registro Nazionale.",
    ore: 20,
    cfdt: 20,
    completato: true,
    dataFine: "2026-04-22",
    progresso: 100,
    lezioni: [
      { id: "l1", titolo: "Modulo 1 - Introduzione alla consulenza digitale", durata: "32:14", completata: true },
      { id: "l2", titolo: "Modulo 2 - Strumenti del consulente moderno", durata: "45:08", completata: true },
      { id: "l3", titolo: "Modulo 3 - Sostenibilità e ESG", durata: "38:55", completata: true },
      { id: "l4", titolo: "Modulo 4 - Etica e Codice Deontologico", durata: "28:30", completata: true },
    ],
    materiali: [
      { id: "m1", nome: "Slide del corso base", size: "2.4 MB" },
      { id: "m2", nome: "Dispensa A.C.D.T.", size: "1.8 MB" },
    ],
    quiz: { totale: 20, superato: true, punteggio: 18, dataCompletamento: "2026-04-22" },
  },
  {
    id: "c2",
    titolo: "Masterclass GDPR e Privacy Digitale",
    descrizione: "Approfondimento sul GDPR a cura del partner Pigreco.",
    ore: 8,
    cfdt: 8,
    completato: true,
    dataFine: "2026-05-30",
    progresso: 100,
    lezioni: [
      { id: "l1", titolo: "Fondamenti GDPR", durata: "42:10", completata: true },
      { id: "l2", titolo: "DPO e responsabilità", durata: "36:25", completata: true },
      { id: "l3", titolo: "Casi studio reali", durata: "51:00", completata: true },
    ],
    materiali: [
      { id: "m1", nome: "Checklist GDPR", size: "650 KB" },
    ],
    quiz: { totale: 15, superato: true, punteggio: 14, dataCompletamento: "2026-05-30" },
  },
  {
    id: "c3",
    titolo: "Workshop AI per Consulenti (E.S.S.E.)",
    descrizione: "Introduzione pratica all'uso dell'intelligenza artificiale.",
    ore: 6,
    cfdt: 6,
    completato: false,
    dataFine: null,
    progresso: 40,
    lezioni: [
      { id: "l1", titolo: "Cos'è l'AI generativa", durata: "25:30", completata: true },
      { id: "l2", titolo: "Prompt engineering base", durata: "31:12", completata: true },
      { id: "l3", titolo: "AI per la consulenza", durata: "28:45", completata: false },
      { id: "l4", titolo: "Etica e limiti dell'AI", durata: "22:00", completata: false },
      { id: "l5", titolo: "Workshop finale", durata: "40:00", completata: false },
    ],
    materiali: [
      { id: "m1", nome: "Cheatsheet prompt", size: "320 KB" },
      { id: "m2", nome: "Esempi pratici", size: "1.1 MB" },
    ],
    quiz: { totale: 10, superato: false, punteggio: null, dataCompletamento: null },
  },
];

// ----- CATALOGO CORSI (acquistabili) -----
export const MOCK_CATALOGO = [
  {
    id: "cat1",
    titolo: "Sostenibilità Digitale Avanzata",
    categoria: "Sostenibilità",
    descrizione: "Strategie ESG, bilanci di sostenibilità e reporting per il consulente moderno.",
    ore: 12,
    cfdt: 12,
    prezzo: 89.00,
    gratisPremium: true,
    rating: 4.8,
    iscritti: 142,
    livello: "Intermedio",
    immagine: "https://images.unsplash.com/photo-1535378917042-10a22c95931a?w=600&q=80",
  },
  {
    id: "cat2",
    titolo: "AI e Automazione per Consulenti",
    categoria: "Intelligenza Artificiale",
    descrizione: "Sfruttare ChatGPT, Claude e tool AI nella consulenza quotidiana.",
    ore: 10,
    cfdt: 10,
    prezzo: 79.00,
    gratisPremium: true,
    rating: 4.9,
    iscritti: 287,
    livello: "Base",
    immagine: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&q=80",
  },
  {
    id: "cat3",
    titolo: "Cybersecurity per Studi Professionali",
    categoria: "Sicurezza",
    descrizione: "Proteggi i dati dei tuoi clienti: NIS2, backup, password e phishing.",
    ore: 8,
    cfdt: 8,
    prezzo: 59.00,
    gratisPremium: false,
    rating: 4.7,
    iscritti: 98,
    livello: "Base",
    immagine: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&q=80",
  },
  {
    id: "cat4",
    titolo: "Marketing Digitale Etico",
    categoria: "Marketing",
    descrizione: "SEO, social media e ADV nel rispetto del codice deontologico A.C.D.T.",
    ore: 15,
    cfdt: 15,
    prezzo: 129.00,
    gratisPremium: false,
    rating: 4.6,
    iscritti: 65,
    livello: "Avanzato",
    immagine: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80",
  },
  {
    id: "cat5",
    titolo: "Blockchain & Web3 per Consulenti",
    categoria: "Innovazione",
    descrizione: "Capire cripto, NFT, smart contract e implicazioni fiscali.",
    ore: 10,
    cfdt: 10,
    prezzo: 99.00,
    gratisPremium: false,
    rating: 4.5,
    iscritti: 43,
    livello: "Avanzato",
    immagine: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=600&q=80",
  },
  {
    id: "cat6",
    titolo: "Soft Skills per il Consulente",
    categoria: "Personal Branding",
    descrizione: "Public speaking, negoziazione e gestione del cliente difficile.",
    ore: 6,
    cfdt: 6,
    prezzo: 0,
    gratisPremium: true,
    rating: 4.9,
    iscritti: 521,
    livello: "Base",
    immagine: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&q=80",
  },
];

export const MOCK_NOTIFICHE = [
  { id: 1, t: "Nuovo evento disponibile", desc: "Masterclass Sostenibilità Digitale - 15 Luglio", time: "2 ore fa", letta: false },
  { id: 2, t: "Promemoria CFDT", desc: "Ti mancano 6 CFDT per il rinnovo annuale", time: "1 giorno fa", letta: false },
  { id: 3, t: "Pagamento confermato", desc: "Tesseramento ACDT 2026 ricevuto", time: "3 mesi fa", letta: true },
];

// ----- ADMIN MOCK -----
export const MOCK_ADMIN_CORSI = [
  {
    id: "a1",
    titolo: "Consulente Digitale Tecnologico e di Sostenibilità",
    stato: "pubblicato",
    prezzo: 99.00,
    ore: 20,
    cfdt: 20,
    iscritti: 84,
    completati: 67,
    lezioni: 4,
    quiz: 20,
    dataCreazione: "2026-01-10",
  },
  {
    id: "a2",
    titolo: "Masterclass GDPR e Privacy Digitale",
    stato: "pubblicato",
    prezzo: 49.00,
    ore: 8,
    cfdt: 8,
    iscritti: 132,
    completati: 105,
    lezioni: 3,
    quiz: 15,
    dataCreazione: "2026-02-15",
  },
  {
    id: "a3",
    titolo: "Workshop AI per Consulenti",
    stato: "pubblicato",
    prezzo: 0,
    ore: 6,
    cfdt: 6,
    iscritti: 287,
    completati: 198,
    lezioni: 5,
    quiz: 10,
    dataCreazione: "2026-03-01",
  },
  {
    id: "a4",
    titolo: "Sostenibilità Digitale Avanzata",
    stato: "bozza",
    prezzo: 89.00,
    ore: 12,
    cfdt: 12,
    iscritti: 0,
    completati: 0,
    lezioni: 0,
    quiz: 0,
    dataCreazione: "2026-06-10",
  },
];

export const MOCK_ADMIN_ISCRITTI = [
  { id: "u1", nome: "Mario Rossi", email: "mario.rossi@email.it", tessera: "ACDT-2026-0142", progresso: 40, completato: false, dataIscrizione: "2026-06-01" },
  { id: "u2", nome: "Lucia Bianchi", email: "lucia.b@studio.it", tessera: "ACDT-2026-0089", progresso: 100, completato: true, dataIscrizione: "2026-05-12" },
  { id: "u3", nome: "Paolo Verdi", email: "p.verdi@consulenza.it", tessera: "ACDT-2026-0211", progresso: 80, completato: false, dataIscrizione: "2026-05-28" },
  { id: "u4", nome: "Giulia Esposito", email: "giulia.e@gmail.com", tessera: "ACDT-2026-0305", progresso: 100, completato: true, dataIscrizione: "2026-04-18" },
  { id: "u5", nome: "Andrea Conti", email: "andrea.conti@pec.it", tessera: "ACDT-2026-0398", progresso: 20, completato: false, dataIscrizione: "2026-06-12" },
];

export const MOCK_ADMIN_STATS = {
  sociTotali: 412,
  sociAttivi: 387,
  corsiPubblicati: 3,
  corsiBozza: 1,
  fatturatoMese: 4280.00,
  iscrizioniMese: 47,
};

export { LOGO_URL };
